export function deleteAllCookies() {
    const cookies = document.cookie.split(';');

    cookies.forEach((cookie) => {
        const [name] = cookie.split('=');
        document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT`;
    });
}
